import { createFeatureSelector, createSelector } from '@ngrx/store';
import { watchlistAdapter, WatchlistState } from './watchlist.reducer';
import * as WatchlistReducer from './watchlist.reducer';

export const getWatchlistState =
  createFeatureSelector<WatchlistState>('watchlist');

export const {
  selectAll: getAllWatchlist,
  selectEntities: getWatchlistEntities,
  selectIds: getWatchlistIds,
  selectTotal: getTotalWatchlist,
} = watchlistAdapter.getSelectors(getWatchlistState);

export const getSelectedWatchlistId = createSelector(
  getWatchlistState,
  (state: WatchlistState) => state.selectedWatchlistId
);

// export const getSelectedWatchlist = createSelector(
//   getWatchlistEntities,
//   getSelectedWatchlistId,
//   (entities, id) => (id ? entities[id] : null)
// );

export const getCurrentPage = createSelector(
  getWatchlistState,
  (state: WatchlistState) => state.currentPage
);

export const getTotalPages = createSelector(
  getWatchlistState,
  (state: WatchlistState) => state.totalPages
);

export const getTotalItems = createSelector(
  getWatchlistState,
  (state: WatchlistState) => state.totalItems
);

export const getLoading = createSelector(
  getWatchlistState,
  (state: WatchlistState) => state.loading
);
export const selectAllWatchlist = createSelector(
  getWatchlistState,
  WatchlistReducer.selectAllWatchlist
);

export const getSelectedWatchlist = createSelector(
  getWatchlistState,
  (state: WatchlistState) => state.selectedWatchlist
);
